module.exports = __webpack_public_path__ + "static/media/dinesafe-app-restaurant-account.86ccfea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dinesafe-app-restaurant-account.png
// module id = 116
// module chunks = 0